import * as betprofessor from './CashOutModal.styles.betprofessor';
import * as betroyale from './CashOutModal.styles.betroyale';
import * as fiestabet from './CashOutModal.styles.fiestabet';
import * as goldenrush from './CashOutModal.styles.goldenrush';
import * as juicybet from './CashOutModal.styles.juicybet';
import * as puntcity from './CashOutModal.styles.puntcity';
import * as puntgenie from './CashOutModal.styles.puntgenie';
import * as questbet from './CashOutModal.styles.questbet';
import * as sterlingparker from './CashOutModal.styles.sterlingparker';
import * as vikingbet from './CashOutModal.styles.vikingbet';
import * as volcanobet from './CashOutModal.styles.volcanobet';
import * as wellbet from './CashOutModal.styles.wellbet';
import * as forsport from './CashOutModal.styles.forsport';
import * as junglebet from './CashOutModal.styles.junglebet';
import * as betgalaxy from './CashOutModal.styles.betgalaxy';
import * as buffalobet from './CashOutModal.styles.buffalobet';
import * as sugarcastle from './CashOutModal.styles.sugarcastle';
import * as oldgill from './CashOutModal.styles.oldgill';
import * as titanbet from './CashOutModal.styles.titanbet';
import * as slambet from './CashOutModal.styles.slambet';
import * as gigabet from './CashOutModal.styles.gigabet';
import * as betstride from './CashOutModal.styles.betstride';
import * as templebet from './CashOutModal.styles.templebet';
import * as goldenbet888 from './CashOutModal.styles.goldenbet888';
import * as hyperbet from './CashOutModal.styles.hyperbet';
import * as bet777 from './CashOutModal.styles.bet777';
import * as chromabet from './CashOutModal.styles.chromabet';
import * as epicodds from './CashOutModal.styles.epicodds';
import * as bet575 from './CashOutModal.styles.bet575';
import * as pyramidbet from './CashOutModal.styles.pyramidbet';
import * as magnumbet from './CashOutModal.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sugarcastle,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  buffalobet,
  oldgill,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  epicodds,
  bet575,
  pyramidbet,
  magnumbet,
};
